import { NgClass, NgStyle } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'nx-superprep-signin-button',
  standalone: true,
  imports: [NgClass, NgStyle],
  templateUrl: './signin-button.component.html',
  styleUrl: './signin-button.component.scss'
})
export class SigninButtonComponent {
  @Input() provider: 'google'|'apple'|undefined = undefined
  @Input() size: 'small'|'medium'|'large'|'full'|string = 'large'
  @Input() theme: 'primary'|'secondary'|'light'|'dark' = 'light'
  @Input() text = 'Sign In'
  @Input() disabled = false
  @Input() progress = false
  @Input() rounded = true
  @Input() border = true
  @Output() action = new EventEmitter<void>()

  onClick() {
    this.action.emit()
  }

  get label() {
    return this.provider ? `Sign in with ${this.provider.toTitleCase()}` : this.text
  }

  get width() {
    return `${this.size === 'full'
    ? '100%'
    : this.size === 'large'
      ? '18rem'
      : this.size === 'medium'
        ? '14rem'
        : this.size === 'small'
          ? '11rem'
          : this.size
    }`
  }

  get isLoading() {
    return this.progress || false
  }

  rootClassName() { return 'nx-superprep-signin-button' }
  themeClass() { return `${this.theme} ${this.rounded? 'gsi-material-button-rounded' : ''} ${this.border? 'gsi-material-button-border' : ''}` }
  themeStyle() { return {'width': `${this.width}`} }
}
